<template>
  <div v-show="showLogin">
    <div class="login-mask" @click="close"></div>
    <div class="login-content">
      <div class="title">
        <span :class="currentIndex == 0 ?'active':''" @click="tabChange(0)">手机登录<i></i></span>
        <span :class="currentIndex == 1 ?'active':''" @click="tabChange(1)">扫码登录<i></i></span>
      </div>
      <div v-if="currentIndex == 0">
        <div class="form-input">
          <input placeholder="请输入手机号码" v-model="phoneNumber"/>
        </div>
        <div class="form-input">
          <input style="width: 226px" placeholder="请输入验证码" v-model="sendCode"/>
          <button @click="getSendCode" :disabled="btnClick">{{ codeText }}</button>
        </div>
        <button class="login" @click="postPhoneLogin">登录</button>
        <p style="text-align: center">请使用<span @click="modalClick(2)">小鹿角小程序</span>注册账户，可登陆PC端</p>
      </div>
      <div v-if="currentIndex == 1">
        <img class="erweima" :src="'data:image/jpg;base64,'+codeImg"/>
        <p style="text-align: center">请使用<span @click="modalClick(2)">小鹿角小程序</span>注册账户，使用小程序扫码登录</p>
      </div>
    </div>

     <!--        客服-->
    <Modal v-if="showModal" :title="contact.title" :img="contact.img" @close="closeModal"></Modal>
  </div>
</template>

<script>
import {sendCode,phoneLogin,loginGrCode,checkScanLogin,userInfo} from '../../network/api'
import Modal from '../modal/modal'
import store from '../../store'
import Vue from 'vue';
import {Toast} from 'vant';
import { isphoneNumber } from '../../tools'

Vue.use(Toast);
export default {
  name: "login",
  components: { Modal},
  data() {
    return {
      showLogin: true,
      showModal: false,
      currentIndex: 0,
      phoneNumber: '',
      sendCode: '',
      codeImg: '',
      oauthKey: '',
      timerInterval: null,

      websocket: null,
      responseData: null,

      timeNum: 60,
      codeText: '获取验证码',
      btnClick: false,

      contact: {
        title: '在线客服',
        img: require("../../../static/images/code/app.jpeg"),
      },
    }
  },
  destroyed() {
    if (this.websock) {
      this.websock.close() //离开路由之后断开websocket连接
    }
  },
  mounted() {
    console.log()
  },
  methods: {
    //初始化websocket
    initWebSocket() {
      const wsUri = "ws://portal.livemusichina.com/websocket/server/" + this.oauthKey;
      this.websock = new WebSocket(wsUri);
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onopen = this.websocketonopen;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    websocketonopen() { //连接建立之后执行send方法发送数据
      let actions = {"oauthKey": this.oauthKey};
      this.websocketsend(JSON.stringify(actions));
    },
    websocketonerror() {//连接建立失败重连
      this.initWebSocket();
    },
    websocketonmessage(e) { //数据接收
      const redata = JSON.parse(e.data);
      this.responseData = redata;
    },
    websocketsend(Data) {//数据发送
      this.websock.send(Data);
    },
    websocketclose(e) {  //关闭
      console.log('断开连接', e);
    },
    close() {
      this.showLogin = false
      clearInterval(this.timerInterval)
    },
    modalClick(index) {
      this.showModal = true
      if(index == 1) {
        this.showModal = true
        this.contact = {
          title: '下载小鹿角APP',
          img: require("../../../static/images/code/app.jpeg"),
        }
      } else if(index == 2) {
        this.showModal = true
        this.contact = {
          title: '关注小鹿角小程序',
          img: require("../../../static/images/code/program.jpg"),
        }
      }
    },
    closeModal() {
      this.showModal = false
    },
    tabChange(index) {
      this.currentIndex = index
      clearInterval(this.timerInterval)
      if (this.currentIndex == 1) {
        this.getLoginGrCode()
      }
    },
    // 倒计时
    countdownFunc() {
      const that = this
      const t1 = setInterval(function() {
        if (that.timeNum > 1) {
          that.timeNum--
          that.codeText = that.timeNum + 's'
          that.btnClick = true
        } else {
          clearInterval(t1)
          that.timeNum = 60
          that.codeText = '重新获取'
          that.btnClick = false
        }
      }, 1000)
    },

    getSendCode() {
      if (!this.phoneNumber) {
        Toast('请填写手机号')
        return
      }
      sendCode({
        phone: this.phoneNumber,
      }).then(res => {
        this.countdownFunc()
      })
    },
    postPhoneLogin() {
      if (!this.phoneNumber) {
        Toast('请填写手机号')
        return
      }
      if (!isphoneNumber(this.phoneNumber)) {
        Toast('请填写正确的手机号')
        return
      }
      if (!this.sendCode) {
        Toast('请填写验证码')
        return
      }
      phoneLogin({
        phoneNumber: this.phoneNumber,
        sendCode: this.sendCode,
      }).then(res => {
        window.localStorage.setItem("token", res.data.sessionKey)
        // this.login()
        console.log(store)
        store.dispatch('user/changeLoginStatus',true)
        store.dispatch('user/getInfo')
        Toast('登录成功')
        this.showLogin = false
      })
    },
    getLoginGrCode() {
      let that = this
      loginGrCode().then(res => {
        this.codeImg = res.data.url
        this.oauthKey = res.data.oauthKey
        this.timerInterval = setInterval(function (){
          that.postCheckScanLogin(that.oauthKey)
        },2000)
      })
    },
    postCheckScanLogin(oauthKey) {
      checkScanLogin({
        oauthKey: oauthKey
      }).then(res => {
        window.localStorage.setItem("token", res.data)
        store.dispatch('user/changeLoginStatus',true)
        store.dispatch('user/getInfo')
        Toast('登录成功')
        this.showLogin = false
        clearInterval(this.timerInterval)
      }).catch(err => {
        if (err.code == 7501) {
          this.getLoginGrCode()
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.login-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(40, 40, 40, 0.6);
  z-index: 50;
}

.login-content {
  position: fixed;
  left: 50%;
  top: 50%;
  width: 360px;
  height: 389px;
  background: #FFFFFF;
  transform: translate(-50%, -50%);
  border-radius: 16px;
  z-index: 52;

  .title {
    display: flex;
    flex-direction: row;
    padding: 34px 0 10px;

    span {
      font-size: 18px;
      margin-left: 66px;
      cursor: pointer;

      &.active {
        font-weight: 600;
        color: #E70012;

        i {
          background: #E70012;
        }
      }

      i {
        display: block;
        width: 30px;
        height: 4px;
        margin-left: 18px;
        margin-top: 2px;
        background: #ffffff;
      }
    }
  }

  .form-input {
    width: 320px;
    height: 44px;
    line-height: 44px;
    background: #FFFFFF;
    border: 1px solid #DDDDDD;
    margin: 20px auto 0;
    padding: 0 12px;
    display: flex;
    flex-direction: row;

    input {
      width: 100%;
      border: none;
    }

    button {
      width: 70px;
      background: none;
      font-size: 12px;
      color: #E70012;
      cursor: pointer;
    }


  }

  .login {
    display: block;
    width: 320px;
    height: 44px;
    background: #282828;
    margin: 36px auto 0;
    font-size: 12px;
    color: #ffffff;
    cursor: pointer;
  }

  p {
    width: 267px;
    font-size: 12px;
    line-height: 24px;
    margin: 12px auto 0;
    span{
      color: #435DF2;
      cursor: pointer;
    }
  }

  .erweima {
    display: block;
    width: 174px;
    height: 177px;
    margin: 30px auto 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue